export const voiceSupported = () => "speechSynthesis" in window;

export function speak(text, lang) {
  if (!voiceSupported() || !text) return;
  const u = new SpeechSynthesisUtterance(text);
  u.lang = lang === "en" ? "en-US" : "tr-TR";
  const v = window.speechSynthesis.getVoices().find((x) => x.lang?.toLowerCase().startsWith(lang === "en" ? "en" : "tr"));
  if (v) u.voice = v;
  u.rate = 1;
  window.speechSynthesis.speak(u);
}

export const spokenDist = (m, lang) => {
  if (m >= 950) { const km = Math.round(m / 100) / 10; return lang === "en" ? `${km} kilometers` : `${km} kilometre`; }
  const r = Math.max(50, Math.round(m / 50) * 50);
  return lang === "en" ? `${r} meters` : `${r} metre`;
};
